module.exports = __webpack_public_path__ + "img/banner.78fec3d6.jpg";